import React from 'react';
import PropTypes from 'prop-types';
import cx from 'clsx';
import style from 'jss-material-ui';
import { IconButton as MuiIconButton, Tooltip } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getOpacityColor } from 'config/utils';

const styles = (theme, color, classes = {}) => ({
  root: {
    padding: 0,
    borderRadius: '50%'
  },
  buttonDefault: {
    color,
    border: '1px #B2B2B2 solid',
    '&:hover': {
      border: '1px ' + color + ' solid',
      backgroundColor: getOpacityColor(color, 0.1)
    }
  },
  buttonRaised: {
    color: '#ffffff',
    backgroundColor: color,
    '&:hover': {
      border: '1px ' + color + ' solid',
      backgroundColor: getOpacityColor(color, 0.5)
    }
  },
  buttonTransparent: {
    color
  },
  buttonDisabled: {
    backgroundColor: 'unset',
    border: '1px #bfbfbf solid'
  },
  icon: {},
  buttonLg: {
    width: 45,
    height: 45
  },
  iconLg: {
    height: 20
  },
  iconLgFa: {
    height: 25
  },
  buttonMd: {
    width: 20,
    height: 20
  },
  iconMd: {
    height: 15
  },
  iconMdFa: {
    height: 10
  },
  buttonSm: {
    width: 15,
    height: 15
  },
  iconSm: {
    height: 10
  },
  iconSmFa: {
    height: 7
  },

  ...classes
});

const DefaultIconButton = props => {
  const {
    children,
    classes,
    className,
    size = 'md',
    variant = 'default',
    icon,
    iconSize = size,
    color,
    raw = false,
    tooltip,
    ...rest
  } = props;

  const iconButton = (
    <MuiIconButton
      classes={{
			  root: cx({
			    [classes.buttonDefault]: (variant === 'default'),
			    [classes.buttonRaised]: (variant === 'raised'),
			    [classes.buttonTransparent]: (variant === 'transparent'),
			    [classes.buttonLg]: (size === 'lg'),
			    [classes.buttonMd]: (size === 'md'),
			    [classes.buttonSm]: (size === 'sm')
			  }, classes.root, className),
			  disabled: classes.buttonDisabled
      }}
      {...rest}
    >
      {icon
		  ? <FontAwesomeIcon icon={icon} className={cx({
			  [classes.iconLgFa]: (iconSize === 'lg'),
			  [classes.iconMdFa]: (iconSize === 'md'),
			  [classes.iconSmFa]: (iconSize === 'sm')
		  }, classes.icon)}/>
		  : raw
		    ? children
		    : React.cloneElement(children, {
		      className: cx({
		        [classes.iconLg]: (iconSize === 'lg'),
		        [classes.iconMd]: (iconSize === 'md'),
		        [classes.iconSm]: (iconSize === 'sm')
		      }, classes.icon)
		    })
      }
    </MuiIconButton>
  )

  if (tooltip) {
    return (
      <Tooltip title={tooltip}>
        {iconButton}
      </Tooltip>
    );
  } else {
    return iconButton;
  }
}

export const IconButton = style(DefaultIconButton)((theme, { color = 'blue', classes }) => {
  color = (color === 'green')
    ? '#1ab7a7'
    : (color === 'yellow')
      ? '#F39C12'
      : (color === 'red')
        ? '#fc0000'
        : (color === 'blue')
          ? '#0073d1'
          : (color === 'grey')
            ? '#2e2e2e'
            : color;

  return styles(theme, color, classes);
})

IconButton.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.string
};

export default IconButton;
